import {useTranslation} from 'react-i18next'

// Geoprompt's credits are granted by an account manager, not bought: the banner
// above the composer says who to ask.
export function CreditExhaustedNotice() {
  const {t} = useTranslation()
  return <span className='flex-1'>{t('credits.exhausted')}</span>
}
